import { SHOW_TOAST, HIDE_TOAST } from "./actionTypes";

/**
 * Action creator function that creates an action to show a toast message.
 * @param {any} payload - The payload data for the action.
 * @returns {object} An action object with the type SHOW_TOAST and the provided payload.
 */
export const showToast = (payload) => {
  return {
    type: SHOW_TOAST,
    payload
  }
};
/**
 * Action creator function that creates an action to hide the toast.
 * @param {any} payload - The payload for the action (optional)
 * @returns {object} An action object with the type HIDE_TOAST.
 */
export const hideToast = (payload) => {
  return {
    type: HIDE_TOAST
  };

};
